import Vue from 'vue';

Vue.component('configurator-technical-details', {
    data() {
        return {
            selectionExpanded: false,
        };
    },

    computed: {
        makeBoxModelActive() {
            return this.selectionExpanded ? 'active' : '';
        },
    },

    methods: {
        toggleSelectionExpanded() {
            this.selectionExpanded = !this.selectionExpanded;
        },
    },
});
